export default __webpack_public_path__ + "static/media/frontBg.79b88f3c.webp";